import { render, staticRenderFns } from "./TodayResult.vue?vue&type=template&id=2b851bc5&"
import script from "./TodayResult.vue?vue&type=script&lang=js&"
export * from "./TodayResult.vue?vue&type=script&lang=js&"
import style0 from "./TodayResult.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports